var _path, _path2, _rect, _rect2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatacollectorCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Data Collector Cloud") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37,35V79H77V35ZM75,77H39V37H75Z",
    transform: "translate(-37 -35)",
    fill: "#b4ccdd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.46,55.61a4.49,4.49,0,0,0-6.68-5.35,7.48,7.48,0,0,0-14,3.73c0,.13,0,.26,0,.38a6.74,6.74,0,0,0,2.24,13.09h17.2a6,6,0,0,0,1.2-11.85Z",
    transform: "translate(-37 -35)",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.71,
    y: 19.29,
    width: 3.29,
    height: 9.35,
    fill: "#05548e"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.94,
    y: 23.97,
    width: 3.29,
    height: 4.68,
    fill: "#05548e"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "24.16 21.72 24.16 23.45 24.16 27.02 24.16 28.65 27.46 28.65 27.46 24.33 27.46 23.45 27.46 21.72 24.16 21.72",
    fill: "#05548e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatacollectorCloud);
export default __webpack_public_path__ + "static/media/datacollector-cloud.32e5ddd230087c9a70c425d12ad20ea2.svg";
export { ForwardRef as ReactComponent };